// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"ff58ca26","209":"63e12013","375":"cb4a0ae5","457":"b964fea2","488":"f6a61a90","498":"b4e8d70b","525":"3a64be40","672":"38edaadd","736":"dc295d77","741":"8e62ee5d","842":"48a54cba","851":"6b3b4971","879":"2be30753","881":"5b3aa6c9"}[chunkId] + ".chunk.js";
};